import { render, staticRenderFns } from "./HotelButton.vue?vue&type=template&id=3f35e7f5&"
import script from "./HotelButton.vue?vue&type=script&lang=ts&"
export * from "./HotelButton.vue?vue&type=script&lang=ts&"
import style0 from "./styles/index.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports